import 'snippets/card/card';
import './rebuy-product-widget--card';
import './_rebuy-product-widget.scss';